var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right-chart-2"},[_c('dv-scroll-board',{staticClass:"lc3-chart",attrs:{"config":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }